import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(() => ({
  label: {
    letterSpacing: 1.1,
    lineHeight: 1.2,
    textTransform: "uppercase",
  },
}));
export default styles;
